export default __webpack_public_path__ + "static/media/hello-dark.97b5378e.svg";